import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import { useContext } from "react";
import { useAllSharing, useGenerateSharingEmails } from "./apiSharing";
import { SnackbarContext } from "components/context/SnackbarProvider";
import { UserContext } from "components/context/UserProvider";
import { Form } from "components/shared/Form";
import Button from "components/ui/atoms/Button";
import ListSelectField from "components/ui/atoms/formFields/ListSelectField";
import RHFCheckbox from "components/ui/atoms/formFields/RHFCheckbox";
import RHFDatePicker from "components/ui/atoms/formFields/RHFDatePicker";
import { useModal } from "@ebay/nice-modal-react";

const SharingFilterAndSort = ({ state, setState, onClose }) => {
  const theme = useTheme();
  const { user } = useContext(UserContext);
  const { data: sharings, refetch: sharingsRefetch } = useAllSharing();
  const { displayMessage, displayError } = useContext(SnackbarContext);
  const { mutateAsync: generateSharingEmails } = useGenerateSharingEmails();
  const dealSharingModal = useModal("DealSharingDrawer");

  const doGenerateSharingEmails = () => {
    generateSharingEmails({ ...state, user_id: user.id })
      .then((r) =>
        displayMessage(
          "Generation in progress, go to your drafts in gmail for the next steps.",
        ),
      )
      .catch(displayError);
  };

  if (!sharings) return "Loading";

  return (
    <>
      <Card
        sx={{
          backgroundColor: `${theme.palette.secondary.extralight}`,
          my: 1,
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">Sharings</Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Grid container spacing={1} sx={{ width: "100%" }}>
            <Form
              prepareInitialValues={(object) => ({
                sharing: object?.sharing || "",
                created_at__gte: object?.created_at__gte || null,
                created_at__lte: object?.created_at__lte || null,
                include_removed_deals: object?.include_removed_deals || false,
              })}
              onSubmit={(value) => {
                setState(value);
                return state;
              }}
              initialValues={state}
              autoSubmit
            >
              <Grid size={{ xs: 12, md: 6 }}>
                <ListSelectField
                  name="sharing"
                  label="Sharing"
                  options={[["any", "any"]].concat(
                    sharings
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((x) => [
                        x.id,
                        x.name + (!x.is_active ? " (inactive)" : ""),
                      ]),
                  )}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <RHFCheckbox
                  name="include_removed_deals"
                  label="Include removed deals"
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <RHFDatePicker
                  name="created_at__gte"
                  label="Date From"
                  fullWidth
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <RHFDatePicker
                  name="created_at__lte"
                  label="Date To"
                  fullWidth
                />
              </Grid>
            </Form>
          </Grid>
        </CardContent>
        <CardActions>
          <Button
            size="small"
            variant="contained"
            disabled={!state?.sharing || state?.sharing === "any"}
            onClick={() =>
              dealSharingModal
                .show({
                  formType: "update",
                  id: Number(state?.sharing),
                  values: sharings
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((x) => x.id),
                  onDeleted: () => {
                    setState({ ...state, sharing: "" });
                  },
                })
                .then(() => {
                  //setState({ ...state, sharing: "" });
                  sharingsRefetch();
                })
            }
          >
            Modify
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() =>
              dealSharingModal
                .show({ formType: "create" })
                .then(() => sharingsRefetch())
            }
          >
            Create
          </Button>
          <Button
            sx={{ ml: "auto !important" }}
            size="small"
            variant="contained"
            onClick={doGenerateSharingEmails}
            disabled={!(state?.created_at__gte && state?.created_at__lte)}
          >
            Generate Emails
          </Button>
        </CardActions>
      </Card>
    </>
  );
};

export default SharingFilterAndSort;
